/* import __COLOCATED_TEMPLATE__ from './top-part.hbs'; */
import Component from '@ember/component';
import classic from 'ember-classic-decorator';

@classic
export default class SiteDocumentsNoteDiagnosisTreatmentPlanTopPart extends Component {}
